import { useState, useEffect } from "react"
import CustomSpinner from "../../../../components/spinners/CustomSpinner"

// ** Reactstrap Imports
import {
  Input,
  Label,
  Button,
  FormFeedback,
  Modal,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem
} from "reactstrap"

// ** Third Party Components
import * as yup from "yup"
import Select from "react-select"
import { useFormik } from "formik"
import Flatpickr from "react-flatpickr"
import { Plus, Minus, Check, X  } from "react-feather"

const ResponsabilidadCivilForm = (props) => {

  const [open, setOpen] = useState('')

  const toggle = id => {
    open === id ? setOpen() : setOpen(id)
  }

  const [dsTelefonosOficinas, setdsTelefonosOficinas] = useState(0)
  const [drTelefonosOficinas, setdrTelefonosOficinas] = useState(0)
  const [drTelefonosCelulares, setdrTelefonosCelulares] = useState(0)
  const [ctTelefonosOficinas, setctTelefonosOficinas] = useState(0)
  const [ctTelefonosCelulares, setctTelefonosCelulares] = useState(0)
  const [numeroProfesionistas, setnumeroProfesionistas] = useState(0)
  const [numeroClientes, setnumeroClientes] = useState(0)
  const [swtichServiciosProfesionalesExtranjero, setswtichServiciosProfesionalesExtranjero] = useState(false)
  const [contrantanteIsRazonSocialOPersonaFisica, setcontrantanteIsRazonSocialOPersonaFisica] = useState(false)
    
  function datosAsesoria() {
      return {
        datosSolicitante: {
          nombreCompleto: '',
          RFC: '',
          domicilio: '',
          telefonosOficina: [],
          email: '',
          domicilioFiscal: ''
        },
        datosRepresentanteLegal: {
          nombreRazonSocial: '',
          RFC: '',
          domicilio: '',
          telefonosOficina: [],
          telefonosCelulares: [],
          email: ''
        },
        contratacionTercero: {
          nombreRazonSocial: '',
          RFC: '',
          domicilio: '',
          actividad: '',
          anoInicioActividad: '',
          folioMercantil: '',
          telefonosOficina: [],
          telefonosCelulares: [],
          email: '',
          domicilioFiscal: ''
        },
        ultimaActividad3anos: '',
        ingresosObtenidos: '',
        ventasAnoAnterior: '',
        presupuestoAnoEnCurso: '',
        presupuestoAnoProximo: '',
        numPersonasRelacion: '',
        numPersonasConTitulo: '',
        numPersonasSinTitulo: '',
        tituloEspecialidad: '',
        anoTitulo: '',
        autorizacionEjercerActividad: '',
        anosPracticaProfesion: '',
        desempenadoExtranjero: '',
        accionista: '',
        accionista: '',
        ejerceControl: '',
        ejercePredominante: '',
        nombreCliente: '',
        costoServicio: '',
        principalesClientes: [],
        inmueblesPropiosRentados: '',
        usoInmuebles: '',
        ubicacionInmuebles: '',
        rehusadoSeguro: '',
        seguroResponsabilidadCiviActual: '',
        nombreAseguradora: '',
        sumaAsegurada: '',
        errorDesempenoActividad: '',
        hechoActividad: '',
        tipoActividad: '',
        tipoServicios: '',
        profesionistas: [],
        tipoServiciosPrestados: '',
        honorarios: '',
        paisDondeRealiza: '',
        coberturasAdicionales: ''
      }
  }

  const respuestaSiNo = [
    {
      label: "Si",
      value: "Si"
    },
    {
      label: "No",
      value: "No"
    }
  ]

  function initialValues() {
    if (props.accion === 1) {
      return datosAsesoria()
    } else {
      return props.data
    }
  }

  function validationSchema() {
    return yup.object({
      datosSolicitante: yup.object().shape({
        email: yup
          .string()
          .email("Correo invalido")
      }),
      datosRepresentanteLegal: yup.object().shape({
        email: yup
          .string()
          .email("Correo invalido")
      }),
      contratacionTercero: yup.object().shape({
        email: yup
          .string()
          .email("Correo invalido")
      })
    })
  }

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    onSubmit: (data, { resetForm }) => {
      
      data = {
        ...data,
        accion: props.accion,
        tipo: "empresarial",
        nombre: "Responsabilidad Civil para Licenciados en Derecho/Abogado",
        slug: "responsabilidad-civil-abogado"
      }
      props.administrar(data, props.handleSuccess)
      resetForm()
    }
  })

  function createPrincipalesClientesObj() {
    return {
      nombre: '',
      costoServicioRealizado: '',
      servicioDesempenado: ''
    }
  }

  function createProfesionistasObj() {
    return {
      nombre: '',
      relacionTrabajo: '',
      actividadDesempena: ''
    }
  }
   
  function logicaArray(contador, valorContador = 0) { 
    let arr = ''
    let field = ''
    let objectNew = ''
    switch (contador) {
      case 'dsTelefonosOficinas': 
        setdsTelefonosOficinas(valorContador)
        field = "datosSolicitante['telefonosOficina']"
        arr = formik.values.datosSolicitante.telefonosOficina
        objectNew = {telefono:''}
      break
      case 'drTelefonosOficinas': 
        setdrTelefonosOficinas(valorContador)
        field = "datosRepresentanteLegal['telefonosOficina']"
        arr = formik.values.datosRepresentanteLegal.telefonosOficina
        objectNew = {telefono:''}
      break
      case 'drTelefonosCelulares': 
        setdrTelefonosCelulares(valorContador)
        field = "datosRepresentanteLegal['telefonosCelulares']"
        arr = formik.values.datosRepresentanteLegal.telefonosCelulares
        objectNew = {telefono:''}
      break
      case 'ctTelefonosOficinas': 
        setctTelefonosOficinas(valorContador)
        field = "contratacionTercero['telefonosOficina']"
        arr = formik.values.contratacionTercero.telefonosOficina
        objectNew = {telefono:''}
      break
      
      case 'ctTelefonosCelulares': 
        setctTelefonosCelulares(valorContador)
        field = "contratacionTercero['telefonosCelulares']"
        arr = formik.values.contratacionTercero.telefonosCelulares
        objectNew = {telefono:''}
      break
      case 'numeroClientes': 
        setnumeroClientes(valorContador)
        field = "principalesClientes"
        arr = formik.values.principalesClientes
        objectNew = createPrincipalesClientesObj()
      break
      
      case 'numeroProfesionistas': 
        setnumeroProfesionistas(valorContador)
        field = "profesionistas"
        arr = formik.values.profesionistas
        objectNew = createProfesionistasObj()
      break
    }
    let  diferencia   =  valorContador - arr.length
    const isNegative  =  diferencia < 0 
    diferencia  = isNegative ? (diferencia * -1) : diferencia 
    for (let i = 1; i <= diferencia; i++) {
      if (isNegative) {
        arr.pop()
      } else {
        arr = [...arr, objectNew]
      }
    }
    formik.setFieldValue(field, arr)
  }

  function logicaContadores(contador, tipo = true) { 
    let valorContador = 0
    switch (contador) {
      case 'dsTelefonosOficinas': 
        valorContador = dsTelefonosOficinas
      break
      case 'drTelefonosOficinas': 
      valorContador = drTelefonosOficinas
      break
      case 'drTelefonosCelulares': 
        valorContador = drTelefonosCelulares
      break
      case 'ctTelefonosOficinas': 
      valorContador = ctTelefonosOficinas
      break
      case 'ctTelefonosCelulares': 
        valorContador = ctTelefonosCelulares
      break
      case 'numeroProfesionistas': 
        valorContador = numeroProfesionistas
      break
      case 'numeroClientes': 
        valorContador = numeroClientes
      break
    }
    if (tipo) {
      valorContador = parseInt(valorContador) + 1 
    } else {
      valorContador = parseInt(valorContador) > 0 ? (parseInt(valorContador) - 1) : 0 
    }
      logicaArray(contador, parseInt(valorContador))
  }

  useEffect(() => {
    logicaArray('dsTelefonosOficinas', dsTelefonosOficinas)
  }, [dsTelefonosOficinas])

  useEffect(() => {
    formik.setFieldValue('tipoServiciosPrestados', '')
    formik.setFieldValue('honorarios', '')
    formik.setFieldValue('paisDondeRealiza', '')
  }, [swtichServiciosProfesionalesExtranjero])

  useEffect(() => {
    formik.setFieldValue('profesionistas', [])
    setnumeroProfesionistas(0)
  }, [contrantanteIsRazonSocialOPersonaFisica])

  useEffect(() => {
    logicaArray('numeroProfesionistas', numeroProfesionistas)
  }, [numeroProfesionistas])

  useEffect(() => {
    logicaArray('drTelefonosOficinas', drTelefonosOficinas)
  }, [drTelefonosOficinas])

  useEffect(() => {
    logicaArray('drTelefonosCelulares', drTelefonosCelulares)
  }, [drTelefonosCelulares])

  useEffect(() => {
    logicaArray('ctTelefonosOficinas', ctTelefonosOficinas)
  }, [ctTelefonosOficinas])
  
  useEffect(() => {
    logicaArray('numeroClientes', numeroClientes)
  }, [numeroClientes])

  useEffect(() => {
    logicaArray('numeroProfesionistas', numeroProfesionistas)
  }, [numeroProfesionistas])

  return (
    <div>
      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Responsabilidad Civil para Licenciados en Derecho/Abogado</h1>
      {/* Sección del solicitante */}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12 mb-2">Datos del solicitante</h3>
        {/* nombreCompleto */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Nombre completo
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosSolicitante.nombreCompleto}
            invalid={formik.errors.datosSolicitante?.nombreCompleto && true}
            onChange={(e) => {
              formik.setFieldValue("datosSolicitante['nombreCompleto']", e.target.value)
            }}
          />
          {formik.errors.datosSolicitante?.nombreCompleto && (
            <FormFeedback>{formik.errors.datosSolicitante?.nombreCompleto}</FormFeedback>
          )}
        </div>
        {/* RFC */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            RFC
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosSolicitante.RFC}
            invalid={formik.errors.datosSolicitante?.RFC && true}
            onChange={(e) => {
              formik.setFieldValue("datosSolicitante['RFC']", e.target.value)
            }}
          />
          {formik.errors.datosSolicitante?.RFC && (
            <FormFeedback>{formik.errors.datosSolicitante?.RFC}</FormFeedback>
          )}
        </div>
        {/* domicilio */}
        <div className="col-12  col-lg-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Domicilio con CP
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosSolicitante.domicilio}
            invalid={formik.errors.datosSolicitante?.domicilio && true}
            onChange={(e) => {
              formik.setFieldValue("datosSolicitante['domicilio']", e.target.value)
            }}
          />
          {formik.errors.datosSolicitante?.domicilio && (
            <FormFeedback>{formik.errors.datosSolicitante?.domicilio}</FormFeedback>
          )}
        </div>
        {/* Dirección de correo */}
        <div className="col-12  col-lg-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Dirección de correo
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosSolicitante.email}
            invalid={formik.errors.datosSolicitante?.email && true}
            onChange={(e) => {
              formik.setFieldValue("datosSolicitante['email']", e.target.value)
            }}
          />
          {formik.errors.datosSolicitante?.email && (
            <FormFeedback>{formik.errors.datosSolicitante?.email}</FormFeedback>
          )}
        </div>
        {/* domicilioFiscal */}
        <div className="col-12   mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Domicilio Fiscal con CP
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosSolicitante.domicilioFiscal}
            invalid={formik.errors.datosSolicitante?.domicilioFiscal && true}
            onChange={(e) => {
              formik.setFieldValue("datosSolicitante['domicilioFiscal']", e.target.value)
            }}
          />
          {formik.errors.datosSolicitante?.domicilioFiscal && (
            <FormFeedback>{formik.errors.datosSolicitante?.domicilioFiscal}</FormFeedback>
          )}
        </div>
        {/* telefonos */}
        <div className="col-12 col-md-6 mb-2">
          <div className="col-12 col-md-12 mb-1">
            <Label className="form-label fw-bolder">
              Telefonos de oficina:
            </Label>
            <div className="d-flex justify-content-center">
              <Button
                className="round"
                color="success"
                size="sm"
                onClick={() => { logicaContadores('dsTelefonosOficinas', false) }}
              >
                {" "}
                <Minus />{" "}
              </Button>
              <Input
                onChange={(e) => {
                  setdsTelefonosOficinas(e.target.value)
                }}
                value={dsTelefonosOficinas}
                style={{ width: "70px" }}
                className="mx-1 text-center text-dark"
                type="number"
              />
              <Button
                className="round"
                color="success"
                size="sm"
                onClick={() => { logicaContadores('dsTelefonosOficinas', true) }}
              >
                {" "}
                <Plus />{" "}
              </Button>
            </div>
          </div>
          {formik.values.datosSolicitante.telefonosOficina.length > 0 &&
            formik.values.datosSolicitante.telefonosOficina.map((_item, index) => (
              
            <div className="col-12 col-md-3 w-input">
              <Label className="form-label fw-bolder" for="tipo">
                Teléfono # {index + 1}:
              </Label>
              <Input
                type="number"
                // invalid={formik.errors.dependientes[index].edad && true}
                value={formik.values.datosSolicitante.telefonosOficina[index]}
                onChange={(e) => {
                  formik.setFieldValue(`datosSolicitante.telefonosOficina[${index}]`, e.target.value)
                }}
              />
            </div>
            ))}
        </div>
      </div>
      {/* Sección del representante */}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12">Datos del representante legal</h3>
        {/* nombreCompleto */}
        <div className="col-12 col-md-6 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Nombre completo/razón social
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosRepresentanteLegal.nombreCompleto}
            invalid={formik.errors.datosRepresentanteLegal?.nombreCompleto && true}
            onChange={(e) => {
              formik.setFieldValue("datosRepresentanteLegal['nombreCompleto']", e.target.value)
            }}
          />
          {formik.errors.datosRepresentanteLegal?.nombreCompleto && (
            <FormFeedback>{formik.errors.datosRepresentanteLegal?.nombreCompleto}</FormFeedback>
          )}
        </div>
        {/* RFC */}
        <div className="col-12 col-md-6 w-input mb-1">
          <Label className="form-label fw-bolder" >
            RFC
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosRepresentanteLegal.RFC}
            invalid={formik.errors.datosRepresentanteLegal?.RFC && true}
            onChange={(e) => {
              formik.setFieldValue("datosRepresentanteLegal['RFC']", e.target.value)
            }}
          />
          {formik.errors.datosRepresentanteLegal?.RFC && (
            <FormFeedback>{formik.errors.datosRepresentanteLegal?.RFC}</FormFeedback>
          )}
        </div>
        {/* domicilio */}
        <div className="col-12 col-lg-6 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Domicilio con CP
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosRepresentanteLegal.domicilio}
            invalid={formik.errors.datosRepresentanteLegal?.domicilio && true}
            onChange={(e) => {
              formik.setFieldValue("datosRepresentanteLegal['domicilio']", e.target.value)
            }}
          />
          {formik.errors.datosRepresentanteLegal?.domicilio && (
            <FormFeedback>{formik.errors.datosRepresentanteLegal?.domicilio}</FormFeedback>
          )}
        </div>
        {/* nombreCompleto */}
        <div className="col-12 col-lg-6 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Dirección de correo
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosRepresentanteLegal.email}
            invalid={formik.errors.datosRepresentanteLegal?.email && true}
            onChange={(e) => {
              formik.setFieldValue("datosRepresentanteLegal['email']", e.target.value)
            }}
          />
          {formik.errors.datosRepresentanteLegal?.email && (
            <FormFeedback>{formik.errors.datosRepresentanteLegal?.email}</FormFeedback>
          )}
        </div>
        <div className=" col-12 d-flex">
          {/* telefonos */}
          <div className="col-6 mb-2">
            <div className="col-12 col-md-12 mb-1">
              <Label className="form-label fw-bolder">
                Telefonos de oficina:
              </Label>
              <div className="d-flex justify-content-center">
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('drTelefonosOficinas', false) }}
                >
                  {" "}
                  <Minus />{" "}
                </Button>
                <Input
                  onChange={(e) => {
                    setdrTelefonosOficinas(e.target.value)
                  }}
                  value={drTelefonosOficinas}
                  style={{ width: "70px" }}
                  className="mx-1 text-center text-dark"
                  type="number"
                />
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('drTelefonosOficinas', true) }}
                >
                  {" "}
                  <Plus />{" "}
                </Button>
              </div>
            </div>
            {formik.values.datosRepresentanteLegal.telefonosOficina.length > 0 &&
              formik.values.datosRepresentanteLegal.telefonosOficina.map((_item, index) => (
                
              <div className="col-8 justify-center w-input">
                <Label className="form-label fw-bolder" for="tipo">
                  Teléfono # {index + 1}:
                </Label>
                <Input
                  type="number"
                  // invalid={formik.errors.dependientes[index].edad && true}
                  value={formik.values.datosRepresentanteLegal.telefonosOficina[index]}
                  onChange={(e) => {
                    formik.setFieldValue(`datosRepresentanteLegal.telefonosOficina[${index}]`, e.target.value)
                  }}
                />
              </div>
              ))}
          </div>
          {/* telefonos */}
          <div className="col-6 mb-2">
            <div className="col-12 col-md-12 mb-1">
              <Label className="form-label fw-bolder">
                Telefonos Celular:
              </Label>
              <div className="d-flex justify-content-center">
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('drTelefonosCelulares', false) }}
                >
                  {" "}
                  <Minus />{" "}
                </Button>
                <Input
                  onChange={(e) => {
                    setdrTelefonosCelulares(e.target.value)
                  }}
                  value={drTelefonosCelulares}
                  style={{ width: "70px" }}
                  className="mx-1 text-center text-dark"
                  type="number"
                />
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('drTelefonosCelulares', true) }}
                >
                  {" "}
                  <Plus />{" "}
                </Button>
              </div>
            </div>
            {formik.values.datosRepresentanteLegal.telefonosCelulares.length > 0 &&
              formik.values.datosRepresentanteLegal.telefonosCelulares.map((_item, index) => (
                
              <div className="col-8 justify-center w-input">
                <Label className="form-label fw-bolder" for="tipo">
                  Teléfono # {index + 1}:
                </Label>
                <Input
                  type="number"
                  // invalid={formik.errors.dependientes[index].edad && true}
                  value={formik.values.datosRepresentanteLegal.telefonosCelulares[index]}
                  onChange={(e) => {
                    formik.setFieldValue(`datosRepresentanteLegal.telefonosCelulares[${index}]`, e.target.value)
                  }}
                />
              </div>
              ))}
          </div>
        </div>
      </div>
      {/* Sección del Contratación a través de un tercero */}
      <div className="col-12 d-flex flex-wrap mt-2 mb-4">
        <h3 className="col-12 mb-2">Contratación a través de un tercero</h3>
        {/* nombreCompleto */}
        <div className="col-12 col-md-6 col-lg-4 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Nombre completo/Razón social
          </Label>
          <Input
            placeholder=""
            value={formik.values.contratacionTercero.nombreCompleto}
            invalid={formik.errors.contratacionTercero?.nombreCompleto && true}
            onChange={(e) => {
              formik.setFieldValue("contratacionTercero['nombreCompleto']", e.target.value)
            }}
          />
          {formik.errors.contratacionTercero?.nombreCompleto && (
            <FormFeedback>{formik.errors.contratacionTercero?.nombreCompleto}</FormFeedback>
          )}
        </div>
        {/* RFC */}
        <div className="col-12 col-md-6 col-lg-4 w-input mb-1">
          <Label className="form-label fw-bolder" >
            RFC
          </Label>
          <Input
            placeholder=""
            value={formik.values.contratacionTercero.RFC}
            invalid={formik.errors.contratacionTercero?.RFC && true}
            onChange={(e) => {
              formik.setFieldValue("contratacionTercero['RFC']", e.target.value)
            }}
          />
          {formik.errors.contratacionTercero?.RFC && (
            <FormFeedback>{formik.errors.contratacionTercero?.RFC}</FormFeedback>
          )}
        </div>
        {/* domicilio */}
        <div className="col-12  col-lg-4 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Domicilio con CP
          </Label>
          <Input
            placeholder=""
            value={formik.values.contratacionTercero.domicilio}
            invalid={formik.errors.contratacionTercero?.domicilio && true}
            onChange={(e) => {
              formik.setFieldValue("contratacionTercero['domicilio']", e.target.value)
            }}
          />
          {formik.errors.contratacionTercero?.domicilio && (
            <FormFeedback>{formik.errors.contratacionTercero?.domicilio}</FormFeedback>
          )}
        </div>
        {/* actividad */}
        <div className="col-12 col-md-4 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Actividad, Giro mercantil u objeto social
          </Label>
          <Input
            placeholder=""
            value={formik.values.contratacionTercero.actividad}
            invalid={formik.errors.contratacionTercero?.actividad && true}
            onChange={(e) => {
              formik.setFieldValue("contratacionTercero['actividad']", e.target.value)
            }}
          />
          {formik.errors.contratacionTercero?.actividad && (
            <FormFeedback>{formik.errors.contratacionTercero?.actividad}</FormFeedback>
          )}
        </div>
        {/* anoInicioActividad */}
        <div className="col-12 col-md-4 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Año de inicio de actividades
          </Label>
          <Input
            placeholder=""
            value={formik.values.contratacionTercero.anoInicioActividad}
            invalid={formik.errors.contratacionTercero?.anoInicioActividad && true}
            onChange={(e) => {
              formik.setFieldValue("contratacionTercero['anoInicioActividad']", e.target.value)
            }}
          />
          {formik.errors.contratacionTercero?.anoInicioActividad && (
            <FormFeedback>{formik.errors.contratacionTercero?.anoInicioActividad}</FormFeedback>
          )}
        </div>
        {/* folioMercantil */}
        <div className="col-12 col-md-4 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Folio Mercantil
          </Label>
          <Input
            placeholder=""
            value={formik.values.contratacionTercero.folioMercantil}
            invalid={formik.errors.contratacionTercero?.folioMercantil && true}
            onChange={(e) => {
              formik.setFieldValue("contratacionTercero['folioMercantil']", e.target.value)
            }}
          />
          {formik.errors.contratacionTercero?.folioMercantil && (
            <FormFeedback>{formik.errors.contratacionTercero?.folioMercantil}</FormFeedback>
          )}
        </div>
        {/* nombreCompleto */}
        <div className="col-12 col-lg-6 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Dirección de correo
          </Label>
          <Input
            placeholder=""
            value={formik.values.contratacionTercero.email}
            invalid={formik.errors.contratacionTercero?.email && true}
            onChange={(e) => {
              formik.setFieldValue("contratacionTercero['email']", e.target.value)
            }}
          />
          {formik.errors.contratacionTercero?.email && (
            <FormFeedback>{formik.errors.contratacionTercero?.email}</FormFeedback>
          )}
        </div>
        {/* domicilioFiscal */}
        <div className="col-12 col-lg-6 w-input mb-1">
          <Label className="form-label fw-bolder" >
            Domicilio Fiscal con CP
          </Label>
          <Input
            placeholder=""
            value={formik.values.contratacionTercero.domicilioFiscal}
            invalid={formik.errors.contratacionTercero?.domicilioFiscal && true}
            onChange={(e) => {
              formik.setFieldValue("contratacionTercero['domicilioFiscal']", e.target.value)
            }}
          />
          {formik.errors.contratacionTercero?.domicilioFiscal && (
            <FormFeedback>{formik.errors.contratacionTercero?.domicilioFiscal}</FormFeedback>
          )}
        </div>
        <div className="col-12 d-flex">
          {/* telefonos */}
          <div className="col-6 mb-2">
            <div className="col-12 col-md-12 mb-1 ">
              <Label className="form-label fw-bolder">
                Telefonos de oficina:
              </Label>
              <div className="d-flex justify-content-center">
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('ctTelefonosOficinas', false) }}
                >
                  {" "}
                  <Minus />{" "}
                </Button>
                <Input
                  onChange={(e) => {
                    setctTelefonosOficinas(e.target.value)
                  }}
                  value={ctTelefonosOficinas}
                  style={{ width: "70px" }}
                  className="mx-1 text-center text-dark"
                  type="number"
                />
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('ctTelefonosOficinas', true) }}
                >
                  {" "}
                  <Plus />{" "}
                </Button>
              </div>
            </div>
            {formik.values.contratacionTercero.telefonosOficina.length > 0 &&
              formik.values.contratacionTercero.telefonosOficina.map((_item, index) => (
                
              <div className="col-8 justify-center w-input">
                <Label className="form-label fw-bolder" for="tipo">
                  Teléfono # {index + 1}:
                </Label>
                <Input
                  type="number"
                  // invalid={formik.errors.dependientes[index].edad && true}
                  value={formik.values.contratacionTercero.telefonosOficina[index]}
                  onChange={(e) => {
                    formik.setFieldValue(`contratacionTercero.telefonosOficina[${index}]`, e.target.value)
                  }}
                />
              </div>
              ))}
          </div>
          {/* telefonos */}
          <div className="col-6 mb-2">
            <div className="col-12 col-md-12 mb-1">
              <Label className="form-label fw-bolder">
                Telefonos Celular:
              </Label>
              <div className="d-flex justify-content-center">
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('ctTelefonosCelulares', false) }}
                >
                  {" "}
                  <Minus />{" "}
                </Button>
                <Input
                  onChange={(e) => {
                    setctTelefonosCelulares(e.target.value)
                  }}
                  value={ctTelefonosCelulares}
                  style={{ width: "70px" }}
                  className="mx-1 text-center text-dark"
                  type="number"
                />
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('ctTelefonosCelulares', true) }}
                >
                  {" "}
                  <Plus />{" "}
                </Button>
              </div>
            </div>
            {formik.values.contratacionTercero.telefonosCelulares.length > 0 &&
              formik.values.contratacionTercero.telefonosCelulares.map((_item, index) => (
                
              <div className="col-8 justify-center w-input">
                <Label className="form-label fw-bolder" for="tipo">
                  Teléfono # {index + 1}:
                </Label>
                <Input
                  type="number"
                  // invalid={formik.errors.dependientes[index].edad && true}
                  value={formik.values.contratacionTercero.telefonosCelulares[index]}
                  onChange={(e) => {
                    formik.setFieldValue(`contratacionTercero.telefonosCelulares[${index}]`, e.target.value)
                  }}
                />
              </div>
              ))}
          </div>
        </div>
      </div>
      {/* Detalles de la asesoria */}
      <div className="d-flex flex-wrap">
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Describa la actividad y/o giro en el que ha trabajado durante los ultimo tres años
          </Label>
          <Input
            placeholder=""
            value={formik.values.ultimaActividad3anos}
            invalid={formik.errors.ultimaActividad3anos && true}
            onChange={(e) => {
              formik.setFieldValue("ultimaActividad3anos", e.target.value)
            }}
          />
          {formik.errors.ultimaActividad3anos && (
            <FormFeedback>{formik.errors.ultimaActividad3anos}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Ingresos obtenidos por esta actividad
          </Label>
          <Input
            placeholder=""
            type="number"
            value={formik.values.ingresosObtenidos}
            invalid={formik.errors.ingresosObtenidos && true}
            onChange={(e) => {
              formik.setFieldValue("ingresosObtenidos", e.target.value)
            }}
          />
          {formik.errors.ingresosObtenidos && (
            <FormFeedback>{formik.errors.ingresosObtenidos}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Ventas de año anterior
          </Label>
          <Input
            type="number"
            placeholder=""
            value={formik.values.ventasAnoAnterior}
            invalid={formik.errors.ventasAnoAnterior && true}
            onChange={(e) => {
              formik.setFieldValue("ventasAnoAnterior", e.target.value)
            }}
          />
          {formik.errors.ventasAnoAnterior && (
            <FormFeedback>{formik.errors.ventasAnoAnterior}</FormFeedback>
          )}
        </div> 

        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Presupuesto del año en curso
          </Label>
          <Input
            type="number"
            placeholder=""
            value={formik.values.presupuestoAnoEnCurso}
            invalid={formik.errors.presupuestoAnoEnCurso && true}
            onChange={(e) => {
              formik.setFieldValue("presupuestoAnoEnCurso", e.target.value)
            }}
          />
          {formik.errors.presupuestoAnoEnCurso && (
            <FormFeedback>{formik.errors.presupuestoAnoEnCurso}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Presupuesto del año próximo
          </Label>
          <Input
            placeholder=""
            type="number"
            value={formik.values.presupuestoAnoProximo}
            invalid={formik.errors.presupuestoAnoProximo && true}
            onChange={(e) => {
              formik.setFieldValue("presupuestoAnoProximo", e.target.value)
            }}
          />
          {formik.errors.presupuestoAnoProximo && (
            <FormFeedback>{formik.errors.presupuestoAnoProximo}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Indique el número de personas bajo relación de trabajo con el solicitante 
          </Label>
          <Input
            placeholder=""
            type="number"
            value={formik.values.numPersonasRelacion}
            invalid={formik.errors.numPersonasRelacion && true}
            onChange={(e) => {
              formik.setFieldValue("numPersonasRelacion", e.target.value)
            }}
          />
          {formik.errors.numPersonasRelacion && (
            <FormFeedback>{formik.errors.numPersonasRelacion}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Cuantos de estos tienen Título de su profesión:
          </Label>
          <Input
            placeholder=""
            type="number"
            value={formik.values.numPersonasConTitulo}
            invalid={formik.errors.numPersonasConTitulo && true}
            onChange={(e) => {
              formik.setFieldValue("numPersonasConTitulo", e.target.value)
            }}
          />
          {formik.errors.numPersonasConTitulo && (
            <FormFeedback>{formik.errors.numPersonasConTitulo}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Cuantos de estos no tienen Título de su profesión:
          </Label>
          <Input
            placeholder=""
            type="number"
            value={formik.values.numPersonasSinTitulo}
            invalid={formik.errors.numPersonasSinTitulo && true}
            onChange={(e) => {
              formik.setFieldValue("numPersonasSinTitulo", e.target.value)
            }}
          />
          {formik.errors.numPersonasSinTitulo && (
            <FormFeedback>{formik.errors.numPersonasSinTitulo}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Indique El título de la especialidad
          </Label>
          <Input
            placeholder=""
            value={formik.values.tituloEspecialidad}
            invalid={formik.errors.tituloEspecialidad && true}
            onChange={(e) => {
              formik.setFieldValue("tituloEspecialidad", e.target.value)
            }}
          />
          {formik.errors.tituloEspecialidad && (
            <FormFeedback>{formik.errors.tituloEspecialidad}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Año de otorgamiento del Título
          </Label>
          <Input
            placeholder=""
            type="number"
            value={formik.values.anoTitulo}
            invalid={formik.errors.anoTitulo && true}
            onChange={(e) => {
              formik.setFieldValue("anoTitulo", e.target.value)
            }}
          />
          {formik.errors.anoTitulo && (
            <FormFeedback>{formik.errors.anoTitulo}</FormFeedback>
          )}
        </div>
        <div className="col-12 w-input">
          <Label className="form-label fw-bolder" >
            Autorización Ejercer Actividad, proporciona una de las siguientes datos de autorización para ejercer la autoridad:<br></br>Numero de Cédula Profesional, Patente, nombramiento legal, acreditación, certificación requerida para ejercer la actividad, numero de autorización para operar de la autoridad que corresponda COFEPRIS o SALUBRIDAD U otra autoridad:  
          </Label>
          <Input
            placeholder=""
            value={formik.values.autorizacionEjercerActividad}
            invalid={formik.errors.autorizacionEjercerActividad && true}
            onChange={(e) => {
              formik.setFieldValue("autorizacionEjercerActividad", e.target.value)
            }}
          />
          {formik.errors.autorizacionEjercerActividad && (
            <FormFeedback>{formik.errors.autorizacionEjercerActividad}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            ¿Cuántos años ha practicado de forma efectiva su profesión?
          </Label>
          <Input
            placeholder=""
            type="number"
            value={formik.values.anosPracticaProfesion}
            invalid={formik.errors.anosPracticaProfesion && true}
            onChange={(e) => {
              formik.setFieldValue("anosPracticaProfesion", e.target.value)
            }}
          />
          {formik.errors.anosPracticaProfesion && (
            <FormFeedback>{formik.errors.anosPracticaProfesion}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            ¿Durante el último año ha desempeñado algún cargo en el extranjero?
          </Label>
          <Select
            id="desempenadoExtranjero"
            className="react-select w-100"
            classNamePrefix="select"
            defaultValue={respuestaSiNo[0]}
            value={{
              label: formik.values.desempenadoExtranjero,
              value: formik.values.desempenadoExtranjero
            }}
            onChange={(e) => {
              formik.setFieldValue("desempenadoExtranjero", e.value)
            }}
            options={respuestaSiNo}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.desempenadoExtranjero && (
            <FormFeedback>{formik.errors.desempenadoExtranjero}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Los padres, hijos, abuelos, hermanos , nietos de usted o su cónyuge ,concubina o concubina desempeña o ha desempeñado durante el último año algún cargo en el gobierno mexicano o extranjero ?
          </Label>
          <Select
            id="desempenadoFamiliarExtranjero"
            className="react-select w-100"
            classNamePrefix="select"
            defaultValue={respuestaSiNo[0]}
            value={{
              label: formik.values.desempenadoFamiliarExtranjero,
              value: formik.values.desempenadoFamiliarExtranjero
            }}
            onChange={(e) => {
              formik.setFieldValue("desempenadoFamiliarExtranjero", e.value)
            }}
            options={respuestaSiNo}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.desempenadoFamiliarExtranjero && (
            <FormFeedback>{formik.errors.desempenadoFamiliarExtranjero}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            ¿Es usted accionista de una o mas personas morales?
          </Label>
          <Select
            id="accionista"
            className="react-select w-100"
            classNamePrefix="select"
            defaultValue={respuestaSiNo[0]}
            value={{
              label: formik.values.accionista,
              value: formik.values.accionista
            }}
            onChange={(e) => {
              formik.setFieldValue("accionista", e.value)
            }}
            options={respuestaSiNo}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.accionista && (
            <FormFeedback>{formik.errors.accionista}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            ¿Ejerce control sobre ellos?
          </Label>
          <Select
            id="ejerceControl"
            className="react-select w-100"
            classNamePrefix="select"
            defaultValue={respuestaSiNo[0]}
            value={{
              label: formik.values.ejerceControl,
              value: formik.values.ejerceControl
            }}
            onChange={(e) => {
              formik.setFieldValue("ejerceControl", e.value)
            }}
            options={respuestaSiNo}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.ejerceControl && (
            <FormFeedback>{formik.errors.ejerceControl}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            ¿Ejerce su actividad de manera predominante o exclusiva para algún cliente, empresa o entidad?
          </Label>
          <Select
            id="ejercePredominante"
            className="react-select w-100"
            classNamePrefix="select"
            defaultValue={respuestaSiNo[0]}
            value={{
              label: formik.values.ejercePredominante,
              value: formik.values.ejercePredominante
            }}
            onChange={(e) => {
              formik.setFieldValue("ejercePredominante", e.value)
            }}
            options={respuestaSiNo}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.ejercePredominante && (
            <FormFeedback>{formik.errors.ejercePredominante}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Favor de especificar nombre del cliente, empresa o entidad; 
          </Label>
          <Input
            placeholder=""
            value={formik.values.nombreCliente}
            invalid={formik.errors.nombreCliente && true}
            onChange={(e) => {
              formik.setFieldValue("nombreCliente", e.target.value)
            }}
          />
          {formik.errors.nombreCliente && (
            <FormFeedback>{formik.errors.nombreCliente}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Costo u honorarios por el servicio realizado y/o servicio desempeñado:
          </Label>
          <Input
            placeholder=""
            value={formik.values.costoServicio}
            invalid={formik.errors.costoServicio && true}
            onChange={(e) => {
              formik.setFieldValue("costoServicio", e.target.value)
            }}
          />
          {formik.errors.costoServicio && (
            <FormFeedback>{formik.errors.costoServicio}</FormFeedback>
          )}
        </div>
        {/* principalesClientes array */}
        <div className="col-12 w-input">
          <Label className="form-label fw-bolder" >
          Enlistar cinco de sus principales clientes, costo del servicio realizado y servicio desempeñado. 
          </Label>
          {/* principalesClientes */}
          
          <div className="col-12 mb-2">
            <div className="col-12 col-md-12 mb-1">
              <Label className="form-label fw-bolder">
                Clientes principales:
              </Label>
              <div className="d-flex">
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('numeroClientes', false) }}
                >
                  {" "}
                  <Minus />{" "}
                </Button>
                <Input
                  onChange={(e) => {
                    setnumeroClientes(e.target.value)
                  }}
                  value={numeroClientes}
                  style={{ width: "70px" }}
                  className="mx-1 text-center text-dark"
                  type="number"
                />
                <Button
                  className="round"
                  color="success"
                  disabled={numeroClientes > 4 && true}
                  size="sm"
                  onClick={() => { logicaContadores('numeroClientes', true) }}
                >
                  {" "}
                  <Plus />{" "}
                </Button>
              </div>
            </div>
            {formik.values.principalesClientes.length > 0 &&
              formik.values.principalesClientes.map((_item, index) => (
                <row className="d-flex flex-wrap mb-2">
                  <div className="col-12 justify-center w-input">
                    <Label className="form-label fw-bolder" for="tipo">
                      Cliente principal # {index + 1}:
                    </Label>
                  </div>
                  <div className="col-12 col-md-6 justify-center w-input">
                    <Label className="form-label fw-bolder" for="tipo">
                      Nombre:
                    </Label>
                    <Input
                      value={formik.values.principalesClientes[index].nombre}
                      onChange={(e) => {
                        formik.setFieldValue(`principalesClientes[${index}].nombre`, e.target.value)
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-3 justify-center w-input">
                    <Label className="form-label fw-bolder" for="tipo">
                      Costo del servicio :
                    </Label>
                    <Input
                      value={formik.values.principalesClientes[index].costoServicioRealizado}
                      onChange={(e) => {
                        formik.setFieldValue(`principalesClientes[${index}].costoServicioRealizado`, e.target.value)
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-3 justify-center w-input">
                    <Label className="form-label fw-bolder" for="tipo">
                      Servicio desempeñado:
                    </Label>
                    <Input
                      value={formik.values.principalesClientes[index].servicioDesempenado}
                      onChange={(e) => {
                        formik.setFieldValue(`principalesClientes[${index}].servicioDesempenado`, e.target.value)
                      }}
                    />
                  </div>
                </row>
              ))}
          </div>
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Indique si los inmuebles que utiliza para la prestación de su servicio son propios o rentados ; su uso y ubicación :
          </Label>
          <Input
            placeholder=""
            value={formik.values.inmueblesPropiosRentados}
            invalid={formik.errors.inmueblesPropiosRentados && true}
            onChange={(e) => {
              formik.setFieldValue("inmueblesPropiosRentados", e.target.value)
            }}
          />
          {formik.errors.inmueblesPropiosRentados && (
            <FormFeedback>{formik.errors.inmueblesPropiosRentados}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            ¿Le ha sido rehusado o rescindido un seguro de responsabilidad civil profesional en los últimos tres años?
          </Label>
          <Select
            id="ejercePredominante"
            className="react-select w-100"
            classNamePrefix="select"
            defaultValue={respuestaSiNo[0]}
            value={{
              label: formik.values.ejercePredominante,
              value: formik.values.ejercePredominante
            }}
            onChange={(e) => {
              formik.setFieldValue("ejercePredominante", e.value)
            }}
            options={respuestaSiNo}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.ejercePredominante && (
            <FormFeedback>{formik.errors.ejercePredominante}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            ¿Cuenta con un seguro de responsabilidad civil actualmente?
          </Label>
          <Select
            id="ejercePredominante"
            className="react-select w-100"
            classNamePrefix="select"
            defaultValue={respuestaSiNo[0]}
            value={{
              label: formik.values.seguroResponsabilidadCiviActual,
              value: formik.values.seguroResponsabilidadCiviActual
            }}
            onChange={(e) => {
              formik.setFieldValue("seguroResponsabilidadCiviActual", e.value)
            }}
            options={respuestaSiNo}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.seguroResponsabilidadCiviActual && (
            <FormFeedback>{formik.errors.seguroResponsabilidadCiviActual}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Indicar nombre de la aseguradora:
          </Label>
          <Input
            placeholder=""
            value={formik.values.nombreAseguradora}
            invalid={formik.errors.nombreAseguradora && true}
            onChange={(e) => {
              formik.setFieldValue("nombreAseguradora", e.target.value)
            }}
          />
          {formik.errors.nombreAseguradora && (
            <FormFeedback>{formik.errors.nombreAseguradora}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Suma asegurada:
          </Label>
          <Input
            placeholder=""
            value={formik.values.sumaAsegurada}
            invalid={formik.errors.sumaAsegurada && true}
            onChange={(e) => {
              formik.setFieldValue("sumaAsegurada", e.target.value)
            }}
          />
          {formik.errors.sumaAsegurada && (
            <FormFeedback>{formik.errors.sumaAsegurada}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            ¿Tiene o ha tenido algún error en el desempeño de su actividad que haya originado una reclamación legal a usted o a la empresa que representa?
          </Label>
          <Select
            id="ejercePredominante"
            className="react-select w-100"
            classNamePrefix="select"
            defaultValue={respuestaSiNo[0]}
            value={{
              label: formik.values.errorDesempenoActividad,
              value: formik.values.errorDesempenoActividad
            }}
            onChange={(e) => {
              formik.setFieldValue("errorDesempenoActividad", e.value)
            }}
            options={respuestaSiNo}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.errorDesempenoActividad && (
            <FormFeedback>{formik.errors.errorDesempenoActividad}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Si tiene conocimiento de algún hecho en el ejercicio de su actividad profesional que pudiera conducir a un supuesto de reclamación, favor de detallar:
          </Label>
          <Input
            placeholder=""
            value={formik.values.hechoActividad}
            invalid={formik.errors.hechoActividad && true}
            onChange={(e) => {
              formik.setFieldValue("hechoActividad", e.target.value)
            }}
          />
          {formik.errors.hechoActividad && (
            <FormFeedback>{formik.errors.hechoActividad}</FormFeedback>
          )}
        </div>
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            ¿Describa si la actividad que lleva a cabo es por cuenta propia o laborando para alguna empresa o ambas?
          </Label>
          <Input
            placeholder=""
            value={formik.values.tipoActividad}
            invalid={formik.errors.tipoActividad && true}
            onChange={(e) => {
              formik.setFieldValue("tipoActividad", e.target.value)
            }}
          />
          {formik.errors.tipoActividad && (
            <FormFeedback>{formik.errors.tipoActividad}</FormFeedback>
          )}
        </div>
        {/* tipoServicios array */}
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Indique el tipo de servicios que predominante proporciona usted o la empresa:
          </Label>
          <Input
            defaultChecked={false}
            placeholder=""
            invalid={formik.errors.tipoServicios && true}
            value={formik.values.tipoServicios}
            onChange={(e) => {
              formik.setFieldValue("tipoActividad", e.target.value)
            }}
          />
          {formik.errors.tipoServicios && (
            <FormFeedback>{formik.errors.tipoServicios}</FormFeedback>
          )}
        </div>
        {/* profesionistas array */}
        <div className="col-12 w-input d-flex mt-2 ">
          <div className=" ww-auto mmr-1">
            <Label className='form-label fw-bolder my-auto ' >
              En caso de prestar servicios profesionales en el extranjero, favor de desglosar:
            </Label>
          </div>
          <div className="ww-auto ">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name='input-ServiciosProfesionales' 
                defaultValue={false}
                id='input-ServiciosProfesionales'
                onChange={(e) => {
                  setswtichServiciosProfesionalesExtranjero(e.target.checked)
                }}
              />
              <Label className='form-check-label' for='input-ServiciosProfesionales'>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {swtichServiciosProfesionalesExtranjero === true && (
          <row className="col-12 d-flex flex-wrap">
            <div className="col-12 col-md-4 w-input">
              <Label className="form-label fw-bolder" >
                Tipo de servicios prestados    
              </Label>
              <Input
                placeholder=""
                invalid={formik.errors.tipoServiciosPrestados && true}
                value={formik.values.tipoServiciosPrestados}
                onChange={(e) => {
                  formik.setFieldValue("tipoServiciosPrestados", e.target.value)
                }}
              />
              {formik.errors.tipoServiciosPrestados && (
                <FormFeedback>{formik.errors.tipoServiciosPrestados}</FormFeedback>
              )}
            </div>
            <div className="col-12 col-md-4 w-input">
              <Label className="form-label fw-bolder" >
                Honorarios:
              </Label>
              <Input
                placeholder=""
                invalid={formik.errors.honorarios && true}
                value={formik.values.honorarios}
                onChange={(e) => {
                  formik.setFieldValue("honorarios", e.target.value)
                }}
              />
              {formik.errors.honorarios && (
                <FormFeedback>{formik.errors.honorarios}</FormFeedback>
              )}
            </div>
            <div className="col-12 col-md-4 w-input">
              <Label className="form-label fw-bolder" >
                Pais:
              </Label>
              <Input
                placeholder=""
                invalid={formik.errors.paisDondeRealiza && true}
                value={formik.values.paisDondeRealiza}
                onChange={(e) => {
                  formik.setFieldValue("paisDondeRealiza", e.target.value)
                }}
              />
              {formik.errors.paisDondeRealiza && (
                <FormFeedback>{formik.errors.paisDondeRealiza}</FormFeedback>
              )}
            </div>
          </row>
        )}
        {/* profesionistas array */}
        <div className="col-12 w-input d-flex mt-2 ">
          <div className=" ww-auto mmr-1">
            <Label className='form-label fw-bolder my-auto ' >
              Si la contratante y asegurado es una razón social o persona física:
            </Label>
          </div>
          <div className="ww-auto ">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name='input-contratantes' 
                id='input-contratantes'
                onChange={(e) => {
                  setcontrantanteIsRazonSocialOPersonaFisica(e.target.checked)
                }}
              />
              <Label className='form-check-label' for='input-contratantes'>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {contrantanteIsRazonSocialOPersonaFisica === true && (          
          <div className="col-12 mb-2">
            <div className="col-12 col-md-12 mb-1">
              <Label className="form-label fw-bolder">
                Profesionales
              </Label>
              <div className="d-flex">
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('numeroProfesionistas', false) }}
                >
                  {" "}
                  <Minus />{" "}
                </Button>
                <Input
                  onChange={(e) => {
                    setnumeroProfesionistas(e.target.value)
                  }}
                  value={numeroProfesionistas}
                  style={{ width: "70px" }}
                  className="mx-1 text-center text-dark"
                  type="number"
                />
                <Button
                  className="round"
                  color="success"
                  size="sm"
                  onClick={() => { logicaContadores('numeroProfesionistas', true) }}
                >
                  {" "}
                  <Plus />{" "}
                </Button>
              </div>
            </div>
            {formik.values.profesionistas.length > 0 &&
              formik.values.profesionistas.map((_item, index) => (
                <row className="d-flex flex-wrap mb-2">
                  <div className="col-12 justify-center w-input">
                    <Label className="form-label fw-bolder" for="tipo">
                      Profesionista # {index + 1}:
                    </Label>
                  </div>
                  <div className="col-12 col-md-6 justify-center w-input">
                    <Label className="form-label fw-bolder" for="tipo">
                      Nombre:
                    </Label>
                    <Input
                      value={formik.values.profesionistas[index].nombre}
                      onChange={(e) => {
                        formik.setFieldValue(`profesionistas[${index}].nombre`, e.target.value)
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-3 justify-center w-input">
                    <Label className="form-label fw-bolder" for="tipo">
                      Relación de trabajo:
                    </Label>
                    <Input
                      value={formik.values.profesionistas[index].relacionTrabajo}
                      onChange={(e) => {
                        formik.setFieldValue(`profesionistas[${index}].relacionTrabajo`, e.target.value)
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-3 justify-center w-input">
                    <Label className="form-label fw-bolder" for="tipo">
                      Actividad desempeñada:
                    </Label>
                    <Input
                      value={formik.values.profesionistas[index].actividadDesempena}
                      onChange={(e) => {
                        formik.setFieldValue(`profesionistas[${index}].actividadDesempena`, e.target.value)
                      }}
                    />
                  </div>
                </row>
              ))}
          </div>
        )}
      </div>
      {/* Btn de guardar */}
      <div className=" mb-1 d-flex justify-content-end">
        <Button className="m-1" color="primary" onClick={formik.handleSubmit}>
          {props.accion === 1 ? "Guardar" : "Guardar cambios"}
        </Button>
      </div>
    </div>
  )
}

export default ResponsabilidadCivilForm
